import { render, staticRenderFns } from "./propertyCreditScoreEvaluation.vue?vue&type=template&id=5b10da48&"
import script from "./propertyCreditScoreEvaluation.vue?vue&type=script&lang=js&"
export * from "./propertyCreditScoreEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports